import React, { useEffect, useState } from 'react';
import { ArtRequest } from '../RequestForm';
import './StepStyles.css';

interface ContactStepProps {
  formData: ArtRequest;
  updateFormData: (data: Partial<ArtRequest>) => void;
  onNext: () => void | Promise<void>;
  onBack: () => void;
  submitError?: string | null;
}

const ContactStep: React.FC<ContactStepProps> = ({
  formData,
  updateFormData,
  onNext,
  onBack,
  submitError,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (submitError) setIsLoading(false);
  }, [submitError]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.deliveryMethod === 'mail') {
      if (!(formData.address && formData.city && formData.state && formData.zipCode)) {
        return;
      }
    }
    setIsLoading(true);
    await onNext();
  };

  return (
    <div className="step-container">
      <h2 className="step-title">physical mail or email?</h2>

      <form onSubmit={handleSubmit} className="step-form">
        <div className="form-group">
          <label>Delivery Method *</label>
          <div className="radio-group">
            <label className="radio-option">
              <input
                type="radio"
                name="deliveryMethod"
                value="email"
                checked={formData.deliveryMethod === 'email'}
                onChange={(e) => updateFormData({ deliveryMethod: e.target.value as 'email' | 'mail' })}
              />
              <span className="radio-label">
                <strong>Email</strong> - Digital artwork sent to your email
              </span>
            </label>

            <label className="radio-option">
              <input
                type="radio"
                name="deliveryMethod"
                value="mail"
                checked={formData.deliveryMethod === 'mail'}
                onChange={(e) => updateFormData({ deliveryMethod: e.target.value as 'email' | 'mail' })}
              />
              <span className="radio-label">
                <strong>Physical Mail</strong> - Artwork shipped to your address
              </span>
            </label>
          </div>
        </div>

        {formData.deliveryMethod === 'email' && (
          <>
            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                value={formData.email}
                onChange={(e) => updateFormData({ email: e.target.value })}
                required
                placeholder="Enter your email address"
              />
            </div>
          </>
        )}

        {formData.deliveryMethod === 'mail' && (
          <>
            <div className="form-group">
              <label htmlFor="address">Street Address *</label>
              <input
                type="text"
                id="address"
                value={formData.address}
                onChange={(e) => updateFormData({ address: e.target.value })}
                required
                placeholder="Enter your street address"
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="city">City *</label>
                <input
                  type="text"
                  id="city"
                  value={formData.city}
                  onChange={(e) => updateFormData({ city: e.target.value })}
                  required
                  placeholder="Enter your city"
                />
              </div>

              <div className="form-group">
                <label htmlFor="state">State *</label>
                <input
                  type="text"
                  id="state"
                  value={formData.state}
                  onChange={(e) => updateFormData({ state: e.target.value })}
                  required
                  placeholder="Enter your state"
                />
              </div>

              <div className="form-group">
                <label htmlFor="zipCode">ZIP Code *</label>
                <input
                  type="text"
                  id="zipCode"
                  value={formData.zipCode}
                  onChange={(e) => updateFormData({ zipCode: e.target.value })}
                  required
                  pattern="[0-9]{5}"
                  title="5-digit ZIP code"
                  placeholder="e.g. 90210"
                />
              </div>
            </div>
          </>
        )}

        {submitError && (
          <div className="form-error" role="alert">
            {submitError}
          </div>
        )}

        <div className="button-group">
          <button type="button" className="btn-secondary" onClick={onBack}>
            Back
          </button>
          <button type="submit" className={`btn-primary ${isLoading ? "btn-disabled" : ""}`} disabled={isLoading}>
            {isLoading ? "Submitting..." : "Submit Request"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContactStep; 